<template>
  <div>
    <div class="contact-header">
      <h1 class="heading-text">
        Contacts
        <span @click="addContactDetailbtn()"
          ><i class="glyphicon glyphicon-plus"></i> Add new contact</span
        >
      </h1>

      <div class="search-contacts">
        <form class="content-form">
          <div class="form-group has-feedback">
            <input
              :maxlength="30"
              v-on:keyup="searchContacts()"
              type="text"
              class="form-control"
              placeholder="Search Contacts"
              v-model="searchcon"
            />
            <span
              class="glyphicon glyphicon-search form-control-feedback"
            ></span>
          </div>
        </form>
      </div>
    </div>

    <div v-if="loadingcontacts == true" class="loading">
      <img src="~styles/img/load.gif" alt="" />
    </div>

    <div v-if="loadingcontacts == false" class="contact-table table-responsive">
      <table class="table list-table spacing-table del-table">
        <tbody class="custom-table">
          <template>
            <tr
              class=""
              v-for="getcontacts in getAllContacts"
              :data-id="getcontacts.id"
              :key="getcontacts.id"
            >
              <td class="contact-detail">
                <img class="user-image" src="~styles/img/user.jpg" alt="" />
                {{ getcontacts.name }}
              </td>
              <td>{{ getcontacts.code }}</td>
              <td>{{ getcontacts.number }}</td>
              <td style="white-space: nowrap">
                {{ getcontacts.age }} {{ getcontacts.gender }}
              </td>
              <!-- <td>
                            <a
                            ref="theButton"
                            :data-id="getcontacts.number"
                            @click="editContactDetailBtn()"
                            >
                                <i
                                :data-id="getcontacts.id"
                                :data-name="getcontacts.name"
                                :data-number="getcontacts.number"
                                :data-age="getcontacts.age"
                                :data-gender="getcontacts.gender"
                                :data-details="getcontacts.details"
                                class="el-icon-edit"></i>
                            </a>
                        </td> -->
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <!-- dialogue for adding contact -->
    <el-dialog
      title="Create Contact"
      :visible.sync="addContactDetail"
      width="50%"
    >
      <form class="content-form">
        <div class="form-group">
          <label for="">Name:</label>
          <input
            type="text"
            class="form-control"
            v-model="addNewContact.name"
            autofocus
          />
        </div>

        <div class="form-group">
          <label for=""
            >Number:
            <span class="text-info">(Please use country code)</span></label
          >
          <input
            type="number"
            name="number"
            class="form-control"
            :minlength="10"
            :maxlength="14"
            v-model="addNewContact.number"
          />
        </div>

        <div class="form-group">
          <label for="">Code:</label>
          <input
            type="text"
            class="form-control"
            v-model="addNewContact.code"
            autofocus
          />
        </div>

        <div class="form-group">
          <label for="">Age:</label>
          <input
            type="number"
            class="form-control"
            :maxlength="3"
            v-model="addNewContact.age"
          />
        </div>

        <div class="form-group">
          <label for="">Gender:</label>
          <select class="form-control" v-model="addNewContact.gender">
            <option value="">Select Gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
            <option value="O">Other</option>
          </select>
        </div>

        <div class="form-group">
          <label for="">Add to Group:</label>
          <el-checkbox-group v-model="addNewContact.groups">
            <el-checkbox
              v-for="groupDetaillist in groupDetail"
              :key="groupDetaillist.id"
              :label="groupDetaillist.id"
              >{{ groupDetaillist.group_name }}</el-checkbox
            >
          </el-checkbox-group>
        </div>

        <div class="form-group">
          <label for="">Detail:</label>
          <textarea
            class="form-control message-text"
            rows="3"
            v-model="addNewContact.details"
          ></textarea>
        </div>
      </form>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="addContactDetail = false">Cancel</el-button>
        <el-button type="primary" @click="saveContact()">Save</el-button>
      </span>
    </el-dialog>

    <!-- dialog for editing contact -->
    <el-dialog
      title="Edit Contact"
      :visible.sync="editContactDetail"
      width="50%"
    >
      <div v-if="loadingEditContacts == true" class="loading">
        <img src="~styles/img/load.gif" alt="" />
      </div>

      <form v-if="loadingEditContacts == false" class="content-form">
        <div class="form-group">
          <label for="">Name:</label>
          <input
            type="text"
            class="form-control"
            v-model="editContact.name"
            autofocus
          />
        </div>

        <div class="form-group">
          <label for=""
            >Number:
            <span class="text-info">(Please use country code)</span></label
          >
          <input
            name="number"
            type="number"
            class="form-control"
            :minlength="10"
            :maxlength="14"
            v-model="editContact.number"
          />
        </div>

        <div class="form-group">
          <label for="">Code:</label>
          <input
            type="text"
            class="form-control"
            v-model="editContact.code"
            autofocus
          />
        </div>

        <div class="form-group">
          <label for="">Age:</label>
          <input
            type="number"
            class="form-control"
            :maxlength="3"
            v-model="editContact.age"
          />
        </div>

        <div class="form-group">
          <label for="">Gender:</label>
          <select class="form-control" v-model="editContact.gender">
            <option value="">Select Gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
            <option value="O">Other</option>
          </select>
        </div>

        <div class="form-group">
          <label for="">Add to Group:</label>
          <el-checkbox-group v-model="editContact.groups">
            <el-checkbox
              v-for="groupDetaillist in groupDetail"
              :key="groupDetaillist.id"
              :label="groupDetaillist.id"
              >{{ groupDetaillist.group_name }}</el-checkbox
            >
          </el-checkbox-group>
        </div>

        <div class="form-group">
          <label for="">Detail:</label>
          <textarea
            class="form-control message-text"
            rows="3"
            v-model="editContact.details"
          ></textarea>
        </div>
      </form>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="editContactDetail = false">Cancel</el-button>
        <el-button type="primary" @click="saveEditedContact()">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import {
  getgenericuser,
  getusergroups,
  editgenericuser,
  searchAllContacts,
  addNewContact,
  getAllContacts,
  getHeader
} from "./../../../config";
import Vue from "vue";

export default {
  data() {
    return {
      loadingcontacts: true,
      loadingEditContacts: true,

      searchcon: "",
      addContactDetail: false,
      editContactDetail: false,

      groupDetail: [
        {
          id: "",
          group_name: "",
          group_description: ""
        }
      ],

      addNewContact: {
        name: "",
        number: "",
        code: "",
        groups: [],
        age: "",
        gender: "",
        details: ""
      },

      getAllContacts: [
        {
          id: "",
          name: "",
          code: "",
          number: "",
          age: "",
          gender: "",
          details: ""
        }
      ],

      editContact: {
        id: "",
        name: "",
        code: "",
        number: "",
        groups: [],
        age: "",
        gender: "",
        details: ""
      }
    };
  },

  methods: {
    refreshGroups() {
      axios.get(getusergroups, { headers: getHeader() }).then(Response => {
        // console.log(Response)
        this.groupDetail = Response.data.data;
      });
    },

    addContactDetailbtn() {
      this.refreshGroups();
      this.addContactDetail = true;
    },

    resetContactForm() {
      (this.addNewContact.name = ""),
        (this.addNewContact.number = ""),
        (this.addNewContact.age = ""),
        (this.addNewContact.gender = ""),
        (this.addNewContact.details = ""),
        (this.addNewContact.groups = []);
    },

    saveContact() {
      axios
        .post(addNewContact, this.addNewContact, { headers: getHeader() })
        .then(Response => {
          if (Response.data.error != "true") {
            this.getAllContacts.unshift({
              name: this.addNewContact.name,
              number: this.addNewContact.number,
              age: this.addNewContact.age,
              gender: this.addNewContact.gender
            }),
              this.$notify({
                group: "foo",
                type: "success",
                title: "Contact created",
                text: "Contact has been successfully added."
              }),
              this.$nextTick(function() {
                this.resetContactForm();
              });
          } else {
            // console.log(Response)
            this.$notify({
              group: "foo",
              type: "error",
              title: "Error",
              text: "Contact not Saved"
            });
          }
          this.addContactDetail = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    resetEditContactForm() {
      this.editContact.id = "";
      this.editContact.name = "";
      this.editContact.number = "";
      this.editContact.age = "";
      this.editContact.gender = "";
      this.editContact.details = "";
      this.editContact.groups = [];
    },

    editContactDetailBtn() {
      this.refreshGroups();
      this.loadingEditContacts = true;
      this.editContactDetail = true;
      var clickedid = event.target.dataset.id;

      this.$nextTick(function() {
        axios
          .post(
            getgenericuser,
            { user_id: clickedid },
            { headers: getHeader() }
          )
          .then(Response => {
            if (Response.data.error == "false") {
              this.editContact = Response.data.data;
              this.loadingEditContacts = false;
            }
          });
      });
    },

    saveEditedContact() {
      axios
        .patch(editgenericuser + this.editContact.id, this.editContact, {
          headers: getHeader()
        })
        .then(Response => {
          if (Response.data.error != "true") {
            axios
              .get(getAllContacts, { headers: getHeader() })
              .then(Response => {
                console.log(Response);
                this.getAllContacts = Response.data.data;
              });

            this.resetEditContactForm();

            this.$notify({
              group: "foo",
              type: "success",
              title: "Contact Saved",
              text: "Contact has been successfully added."
            });
          } else {
            console.log(Response);
            this.$notify({
              group: "foo",
              type: "error",
              title: "Contact not Saved",
              text: "Contacts cant be saved"
            });
          }
          this.editContactDetail = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    searchContacts() {
      axios
        .post(
          searchAllContacts,
          { query: this.searchcon },
          { headers: getHeader() }
        )
        .then(Response => {
          // console.log(Response)
          this.getAllContacts = Response.data.data;
        });
    }
  },

  mounted() {
    axios.get(getAllContacts, { headers: getHeader() }).then(Response => {
      // console.log(Response)
      this.getAllContacts = Response.data.data;
    });

    axios.get(getusergroups, { headers: getHeader() }).then(Response => {
      // console.log(Response)
      this.groupDetail = Response.data.data;
      this.$nextTick(function() {
        this.loadingcontacts = false;
      });
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/parts/contactsleads.vue